import React from "react";

export default function Mensaje131095() {
  return (
    <>
      <p>
        <h6>13 DE OCTUBRE DE 1995</h6>
        <br />
        <p>
          (rezando en mi dormitorio) <br />
          <br />
          Amada hijita: <br />
          Con cuanto gusto recibo todas las alabanzas, oraciones y lágrimas de
          amor por mi Divino Hijo Jesús, especialmente en este día. <br />{" "}
          <br />
          El mundo debe Consagrarse a mi Inmaculado Corazón. Ya el tiempo se ha
          acortado, los signos avisarán que se cumplirán, todas las profecías
          que os he dado a través del tiempo, con más intensidad en estos
          últimos años para moveros a una urgente conversión a Dios. Mi corazón
          de Madre sufre por que muchas personas hacen oídos sordos a mis
          llamados urgentes de conversión.
          <br />
          <br />
          El Señor me permite por su gran Misericordia daros avisos de las cosas
          terribles que vendrán para la humanidad, en la oscuridad que se
          aproxima ya no brillará la luz. Las más terribles tribulaciones os
          esperan, las físicas a que se verán sometidos serán totalmente
          insoportables pero también vendrán las del espíritu que serán tan
          tortuosas como jamás sufrió el hombre desde su creación. <br />
          <br />
          El odio del adversario se desatará entonces con todo su furor y hará
          enloquecer a las naciones de la tierra. El fuego que caerá desde el
          Cielo paralizará de terror a todos y el estruendo será tan grande, que
          hará conmover a todo el Universo, después de esto sólo quedarán la 3/4
          partes de la humanidad. <br />
          <br />
          La señal que os he anunciado se verá en favor de los elegidos. Dios
          Padre os dará tiempo para resguardaros en los lugares ya preparados
          para ese gran momento, los hijos que me habéis escuchado ya estarán
          preparados, y en ese día caed de rodillas, cual penitentes y orad así:{" "}
          <br />
          <br />
          Santísima Trinidad que tu Santísima voluntad se cumpla, Tened Piedad
          de nosotros, Tened Piedad, Tened Misericordia, Tened Misericordia.
          ¡Oh! Dios Misericordia, Misericordia. <br />
          <br />
          Por la Sangre del Cordero ten Piedad, <br />
          Por la Pasión del Cordero ten Misericordia, <br />
          Por las Llagas del Cordero ten Piedad. <br />
          Por Tu Hijo el Cordero de Dios escúchanos <br />
          Padre apiádate de nosotros por el Nombre Bendito de tu Hijo Jesús.
          Amén. <br />
          <br />
          Os pido conversión URGENTE al Inmaculado Corazón de María, para
          mitigar estos horrores que sobrevendrán por los pecados, hijita, el
          mundo está navegando en una ciena inmunda, sumergido en toda clase de
          impurezas, ya imposible de comparar, ya que nunca se vio algo así
          desde su creación. El nauseabundo olor sube denso hasta Dios y hay
          pocas almas de oración, ya el castigo está a las puertas. <br />
          <br />
          Mis ruegos detienen la Mano de Dios, Pido más oración, Especialmente
          de los CONSAGRADOS, que oren sin cesar y sobre todo di que amen a
          Dios, el que es SANTO, SANTO, SANTO. <br />
          <br />
          ¡Y Que el Santo Temor a Dios vuelva a los corazones! <br />
          <br />
          Los que crean estas palabras mías y se conviertan se salvarán. Da a
          conocer este mensaje hija, hoy como ayer URGENTE LLAMADO AL AMOR DE
          DIOS. <br />
          <br />
          Te bendigo hijita de mi Corazón. <br />
          Amén, Amén, Amén.
        </p>
      </p>
    </>
  );
}
